import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  "justify-content-center": "",
  wrap: "",
  class: "exam-result"
}
const _hoisted_2 = { xs12: "" }
const _hoisted_3 = {
  key: 1,
  class: "align-center mt-2"
}
const _hoisted_4 = {
  key: 2,
  class: "align-center mt-2"
}
const _hoisted_5 = { key: 3 }
const _hoisted_6 = {
  key: 0,
  class: "guest-update"
}
const _hoisted_7 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_8 = { class: "d-flex align-center flex-wrap exam-result-back" }
const _hoisted_9 = { class: "d-flex align-center flex-wrap exam-result-back" }

import { ref, computed, watch, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { checkMobile } from '../../utils/utils'
import { ROUTER_NAME } from '../../router'
import { examGoalContext, goalPath } from '../../utils/exam_goal_context'
import ExamGoalReturnButton from '../atoms_molecules/ExamGoalReturnButton.vue'
import { LETTER_FORMAT } from '../../utils/constants'
import ExamResultWeb from '../atoms_molecules/ExamResultWeb.vue'
import ExamResultMobile from '../atoms_molecules/ExamResultMobile.vue'
import { headerState } from '../../stores/header'
import api from '../../../api/v2/api'
import Banner from '../../../api/v2/models/banner'
import { userState } from '../../stores/user'
import CommentContainer from '../organisms/CommentContainer.vue'
import { Commentable } from '../../../api/v2/models/comment'
import { examResultState } from '../../stores/exam_result'
import { getLastExamRoute } from '../../utils/setup_exam_router'
import UserUpdateFormView from '../organisms/UserUpdateFormView.vue'
import { getQueryString } from '../../../../helpers/route-helper'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExamResult',
  setup(__props) {

const route = useRoute()
const router = useRouter()

// Reactive Data
const mobile = ref(false)
const banners = ref<Banner[]>([])

// Computed
const exam = computed(() => examResultState.examResult)

const examQScoreHistory = computed(() => examResultState.examQScoreHistory)

const userExam = computed(() => {
  if (userExamId.value) {
    return exam.value?.userExams.find((ue) => `${ue.id}` === userExamId.value)
  }
  return exam.value?.userExam
})

const user = computed(() => userState.user)

const redirectNotFoundPage = computed(() => examResultState.redirectNotFoundPage)

const userExamId = computed(() => getQueryString(route.query, 'user_exam_id'))

const groupQuestions = computed(() => examResultState.groupQuestions)

const commentable = computed<Commentable>(() => ({
  commentableId: userExam.value!.id,
  commentableType: "UserExam"
}))

// Functions
function redirectToNotFoundPage() {
  router.push({
    name: ROUTER_NAME.NOT_FOUND
  })
}

function gotoTop() {
  const goalContext = examGoalContext(route.params.examId as string)
  router.push(goalContext ? goalPath(goalContext) : { name: ROUTER_NAME.MY_EXAM_LIST })
}

function getIsPreviusExamResultRouter() {
  const found = getLastExamRoute([ROUTER_NAME.EXAM_RESULT])
  return !!found
}

// 「戻る」：ゴールから開いたテストはゴールへ。それ以外は今までどおり（直前のテストの画面か、テスト一覧）
function backToExamResult() {
  const goalContext = examGoalContext(route.params.examId as string)
  if (goalContext) {
    router.push(goalPath(goalContext))
    return
  }
  const found = getLastExamRoute([ROUTER_NAME.EXAM_RESULT])
  if (found) {
    router.push(found)
  } else {
    router.push({
      name: ROUTER_NAME.MY_EXAM_LIST
    })
  }
}

// Watchers
watch(() => route, (val) => {
  examResultState.requestExamResult(parseInt(route.params.examId as string)).then(() => {
    headerState.setTitle(exam.value!.name)
    examResultState.setUserExamId(Number(userExamId.value))
    examResultState.getExamResultQuestions()
  })
  examResultState.requestExamQScoreHistories(parseInt(route.params.examId as string))
}, { immediate: true, deep: true })

watch(redirectNotFoundPage, (val) => {
  if (val) {
    examResultState.setRedirectNotFoundPage({ status: false })
    redirectToNotFoundPage()
  }
})

// Lifecycle
onMounted(() => {
  mobile.value = checkMobile()
})

// Created logic (runs immediately)
;(async () => {
  try {
    banners.value = await Promise.resolve(api.banner.index({ type: 'exam_result' }))
    userState.getUser()
  } catch (e) { }
})()

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (exam.value && userExam.value && !userExam.value.finishedAt)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_alert, { type: "warning" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('exam_result.warning_finish_exam', { format: _unref(LETTER_FORMAT).UPTITLECASE })), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ])
      ]))
    : (exam.value && exam.value.hideResult)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("h2", null, "テストの結果は公開していません。", -1 /* CACHED */)),
          _createVNode(_component_v_btn, {
            color: "primary",
            dark: "",
            onClick: gotoTop
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(examGoalContext)(_unref(route).params.examId as string) ? 'ゴールに戻る' : 'テスト一覧戻す'), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]))
      : (exam.value && userExam.value && userExam.value.isWaitingScoreCheck)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[1] || (_cache[1] = _createElementVNode("h2", null, "テストを提出しました。ありがとうございます。", -1 /* CACHED */)),
            _createVNode(_component_v_btn, {
              color: "primary",
              dark: "",
              onClick: gotoTop
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(examGoalContext)(_unref(route).params.examId as string) ? 'ゴールに戻る' : 'テスト一覧戻す'), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]))
        : (exam.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (user.value && user.value.isGuest)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        lg: "8"
                      }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createElementVNode("div", { class: "d-flex flex-column justify-content-center align-items-center" }, [
                            _createElementVNode("div", { class: "fs-1 text-center" }, "テスト結果閲覧はメール登録が必要です"),
                            _createElementVNode("div", { class: "mt-6 fs-6 text-center" }, [
                              _createTextVNode(" お名前、メールアドレス、パスワードを入力して、ユーザー登録ボタンをクリックしてください。"),
                              _createElementVNode("br"),
                              _createTextVNode("※入力したメールアドレスに確認メールが届きます ")
                            ])
                          ], -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _createVNode(UserUpdateFormView, {
                      class: "guest-update-form",
                      showPreview: false,
                      mode: 'guest_update'
                    })
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (!mobile.value)
                      ? (_openBlock(), _createBlock(ExamResultWeb, {
                          key: 0,
                          exam: exam.value,
                          "user-exam": userExam.value,
                          examQScoreHistory: examQScoreHistory.value,
                          groupQuestions: groupQuestions.value,
                          banners: banners.value
                        }, {
                          "result-head": _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(_component_v_btn, {
                                variant: "text",
                                class: "ps-0 ms-1 white-text",
                                onClick: backToExamResult
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { start: "" }, {
                                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                      _createTextVNode("mdi-chevron-left", -1 /* CACHED */)
                                    ]))]),
                                    _: 1 /* STABLE */
                                  }),
                                  _cache[4] || (_cache[4] = _createElementVNode("span", null, "戻る", -1 /* CACHED */))
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(ExamGoalReturnButton, {
                                class: "ms-auto me-2",
                                "exam-id": _unref(route).params.examId as string,
                                color: "white",
                                variant: "flat"
                              }, null, 8 /* PROPS */, ["exam-id"])
                            ])
                          ]),
                          "result-body": _withCtx(() => [
                            _createVNode(CommentContainer, {
                              class: "p-4",
                              commentable: commentable.value,
                              user: user.value
                            }, null, 8 /* PROPS */, ["commentable", "user"])
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["exam", "user-exam", "examQScoreHistory", "groupQuestions", "banners"]))
                      : (_openBlock(), _createBlock(ExamResultMobile, {
                          key: 1,
                          exam: exam.value,
                          "user-exam": userExam.value,
                          examQScoreHistory: examQScoreHistory.value,
                          groupQuestions: groupQuestions.value,
                          banners: banners.value
                        }, {
                          "result-head": _withCtx(() => [
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_component_v_btn, {
                                variant: "text",
                                class: "ps-0 ms-1 white-text",
                                onClick: backToExamResult
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { start: "" }, {
                                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                      _createTextVNode("mdi-chevron-left", -1 /* CACHED */)
                                    ]))]),
                                    _: 1 /* STABLE */
                                  }),
                                  _cache[6] || (_cache[6] = _createElementVNode("span", null, "戻る", -1 /* CACHED */))
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(ExamGoalReturnButton, {
                                class: "ms-auto me-2",
                                "exam-id": _unref(route).params.examId as string,
                                color: "white",
                                variant: "flat"
                              }, null, 8 /* PROPS */, ["exam-id"])
                            ])
                          ]),
                          "comment-body": _withCtx(() => [
                            _createVNode(CommentContainer, {
                              class: "p-4",
                              commentable: commentable.value,
                              user: user.value
                            }, null, 8 /* PROPS */, ["commentable", "user"])
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["exam", "user-exam", "examQScoreHistory", "groupQuestions", "banners"]))
                  ], 64 /* STABLE_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
}
}

})